(function () {
  var cookieName = 'ludic_size_test_group';
  var cookieLifetime = 60 * 24 * 60 * 60;

  function readCookie(name) {
    var prefix = name + '=';
    var cookie = document.cookie.split('; ').find(function (entry) {
      return entry.indexOf(prefix) === 0;
    });

    return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : null;
  }

  function saveGroup(group) {
    document.cookie = cookieName + '=' + encodeURIComponent(group) +
      '; Max-Age=' + cookieLifetime +
      '; Path=/; SameSite=Lax' +
      (window.location.protocol === 'https:' ? '; Secure' : '');
  }

  var override = new URLSearchParams(window.location.search).get('sg');
  var group = override && ['A', 'B'].indexOf(override.toUpperCase()) !== -1
    ? override.toUpperCase()
    : readCookie(cookieName);

  if (group !== 'A' && group !== 'B') {
    group = Math.random() < 0.5 ? 'A' : 'B';
  }

  saveGroup(group);
  window.ludicSizeTestGroup = group;

  var sliderProductForms = document.querySelectorAll('product-form[data-size-test-product="true"]');
  if (!sliderProductForms.length) return;

  sliderProductForms.forEach(function (productForm) {
    productForm.querySelectorAll('input[name="properties[_size_test]"]').forEach(function (input) {
      input.value = group;
    });
  });

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { size_test: group } })
  }).then(function (response) {
    if (!response.ok) {
      throw new Error('Cart group attribute update failed: ' + response.status);
    }

    return response.json();
  }).catch(function (error) {
    console.error('Unable to save the size-test group to the cart.', error);
  });
})();
